var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAntiClockwiseArrowCircle16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0.300000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Workspace-Navigation",
    transform: "translate(-652 -138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-Options",
    transform: "translate(631 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-Icon",
    transform: "translate(20 97)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.169 2.5c1.208 0 2.127.22 2.901.634a4.316 4.316 0 011.796 1.796c.414.774.634 1.693.634 2.901v.338c0 1.208-.22 2.127-.634 2.901a4.316 4.316 0 01-1.796 1.796c-.774.414-1.693.634-2.901.634H7.83c-1.208 0-2.127-.22-2.901-.634a4.316 4.316 0 01-1.796-1.796C2.72 10.296 2.5 9.377 2.5 8.169V7.83c0-1.208.22-2.127.634-2.901A4.316 4.316 0 014.93 3.134",
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-2",
    transform: "matrix(-1 0 0 1 5.25 3)",
    fillRule: "nonzero",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0 3.5V0h3.5"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntiClockwiseArrowCircle16);
export default __webpack_public_path__ + "static/media/anti-clockwise-arrow-circle-16.8f1b6e84.svg";
export { ForwardRef as ReactComponent };